const flattenAllChildren = ({tree, parent = null, path = null}) => {
  const result                       = [];
  const {tipo, id, numero, children} = tree;
  const currentPath                  = (path || `${id}`);

  result.push({tipo, id, numero, parent: parent, path: currentPath});
  if (!children || children?.length === 0) return result;

  children.forEach((child) => {
    const resultChild = flattenAllChildren({tree: child, parent: id, path: `${currentPath}/${child.id}`});
    if (resultChild) result.push(...resultChild);
  });


  return result;
};

export default (object) => {
  const result = flattenAllChildren({tree: object});

  return result.map((item, idx) => (item.ordem = idx + 1) && (item.nivel = item.path.split('/').length) && (item));
}
